import { Box, Container, Typography } from '@mui/material';
import { type ReactNode } from 'react';
import { useBranding } from '../../shared/branding/BrandingProvider';

const visuallyHidden = {
  position: 'absolute' as const,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

interface Props {
  title?: string;
  children: ReactNode;
}

export function AuthLayout({ title, children }: Props): JSX.Element {
  const { branding } = useBranding();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'background.default',
        py: 6,
      }}
    >
      <Container maxWidth="xs" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
        {branding?.logoUrl ? (
          <Box component="img" src={branding.logoUrl} alt="" sx={{ height: 48 }} />
        ) : (
          <Typography variant="h4" component="div">
            ExamFolio
          </Typography>
        )}
        {title && (
          <Typography component="h1" sx={visuallyHidden}>
            {title}
          </Typography>
        )}
        {children}
      </Container>
    </Box>
  );
}
